module.exports = __webpack_public_path__ + "static/whentostoptesting-3bea6c91a38fb80357fea4df988f9c7f.jpg";